import { UserListResponse } from '@/modules/settings/users/services/apiValidationSchemas.ts'
import { UserDetailsDTO } from '@/modules/settings/users/types/User.ts'

export const usersPage1: { data: UserListResponse } = {
  data: {
    results: [
      {
        id: '1',
        email: 'dairoroberto2014@gmail.com',
        name: 'Admin',
        lastName: 'Admin',
        isEnabled: true,
        photo:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/BBC_News_2022_%28Alt%29.svg/250px-BBC_News_2022_%28Alt%29.svg.png',
        phone: '8887766',
        allowsAccessRentability: false,
        branchOfficeName: 'Test',
        roles: ['Report Viewer', 'Admin'],
        isLocked: false
      },
      {
        id: '2',
        email: 'ana.gomez@example.com2',
        name: 'Ana',
        lastName: 'Gómez',
        isEnabled: false,
        photo: null,
        phone: '8887766',
        allowsAccessRentability: false,
        branchOfficeName: 'Test',
        roles: ['tess'],
        isLocked: true
      },
      {
        id: '9',
        email: 'ana.gomez@example.com3',
        name: 'Test',
        lastName: 'Gómez',
        isEnabled: true,
        photo: null,
        phone: '8887766',
        allowsAccessRentability: false,
        branchOfficeName: 'Test',
        roles: ['tess'],
        isLocked: false
      },
      {
        id: '11',
        email: 'test@01.cu',
        name: 'pepe',
        lastName: 'gfgdgdf',
        isEnabled: true,
        photo: null,
        phone: '8887766',
        allowsAccessRentability: false,
        branchOfficeName: 'Test',
        roles: ['tess'],
        isLocked: false
      },
      {
        id: '25',
        email: 'test@02eweee.cu',
        name: 'pepe',
        lastName: 'gfgdgdf',
        isEnabled: true,
        photo: null,
        phone: '8887766',
        allowsAccessRentability: false,
        branchOfficeName: 'Test',
        roles: ['tess'],
        isLocked: false
      },
      {
        id: '26',
        email: 'test@02eeweee.cu',
        name: 'pepe',
        lastName: 'gfgdgdf',
        isEnabled: true,
        photo: null,
        phone: '8887766',
        allowsAccessRentability: false,
        branchOfficeName: 'Test',
        roles: ['Report Viewer', 'tess'],
        isLocked: false
      },
      {
        id: '27',
        email: 'test@02eeweeee.cu',
        name: 'pepe',
        lastName: 'gfgdgdf',
        isEnabled: true,
        photo: null,
        phone: '8887766',
        allowsAccessRentability: false,
        branchOfficeName: 'Test',
        roles: ['Report Viewer', 'tess'],
        isLocked: false
      },
      {
        id: '29',
        email: 'test@02eeweeeeee.cu',
        name: 'pepe',
        lastName: 'gfgdgdf',
        isEnabled: true,
        photo: null,
        phone: '8887766',
        allowsAccessRentability: false,
        branchOfficeName: 'Test',
        roles: ['Report Viewer', 'tess'],
        isLocked: false
      },
      {
        id: '30',
        email: '2@teste.com2',
        name: '2845',
        lastName: 'Test',
        isEnabled: true,
        photo: null,
        phone: '8887766',
        allowsAccessRentability: true,
        branchOfficeName: 'Test',
        roles: ['Report Viewer', 'tess'],
        isLocked: false
      },
      {
        id: '31',
        email: '2@teste.com2w',
        name: '2845',
        lastName: 'Test',
        isEnabled: true,
        photo: null,
        phone: '8887766',
        allowsAccessRentability: true,
        branchOfficeName: 'Test',
        roles: ['Report Viewer', 'tess'],
        isLocked: false
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: true,
      prev: false,
      start: 1,
      end: 10,
      range: [1, 2],
      count: 10,
      pages: 2,
      total: 13,
      limit: 0
    }
  }
}

export const employeesPage1 = {
  message: 'OK.',
  data: [
    {
      id: '1',
      label: 'Juana'
    },
    {
      id: '7',
      label: 'Pedro'
    }
  ]
}

export const userDetail: { data: UserDetailsDTO } = {
  data: {
    id: '1',
    email: 'ana@teste.com',
    name: 'Maria josefa',
    lastName: 'Test',
    phone: '324234234',
    isEnabled: true,
    photo:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/BBC_News_2022_%28Alt%29.svg/250px-BBC_News_2022_%28Alt%29.svg.png',
    allowsAccessRentability: true,
    branchOfficeId: '1',
    branchOfficeName: 'Test',
    roles: [
      {
        id: '3',
        name: 'Administrador'
      },
      {
        id: '4',
        name: 'Cliente'
      }
    ],
    isLocked: false
  }
}
